import { render, staticRenderFns } from "./AddColor.vue?vue&type=template&id=706ea04a&scoped=true&"
import script from "./AddColor.vue?vue&type=script&lang=js&"
export * from "./AddColor.vue?vue&type=script&lang=js&"
import style0 from "./AddColor.vue?vue&type=style&index=0&id=706ea04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ea04a",
  null
  
)

export default component.exports